import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/settings/messages";
import { keysToCamelCase } from "lib/helpers";

function* getAdminBatteryServiceAreas(action = { payload: {} }) {
  const { success, data, error } = yield* makeRequest.get("/battery_service_areas", action.payload);

  if (success && data) {
    let out = [];
    if (data.body.battery_service_areas) {
      out = data.body.battery_service_areas.map((s) => keysToCamelCase(s));
    }
    yield put(actions.setAdminBatteryServiceAreas(out));
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_BATTERY_SERVICE_AREAS_LIST,
    });
  }

  return null;
}

export default getAdminBatteryServiceAreas;
